import { Data } from '@angular/router';
import { of } from 'rxjs';

export class ReduxModelMockSpec {
    model: Data;

    get data() {
        return this.model;
    }

    set data(model) {
        this.model = model;
    }

    getState() {
        return of(this.model);
    }
}
